namespace AgerLMS.LMS {
    export enum AfterGraduationTitles {
        Profesor = 1,
        Docent = 2,
        DkOgrUyesi = 3,
        UzmanDoktor = 4,
        AsistanDoktor = 5
    }
    Serenity.Decorators.registerEnumType(AfterGraduationTitles, 'AgerLMS.LMS.AfterGraduationTitles');
}
